// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3LxWB","content":"RecentSearches_content__GTpBc"};